__turbopack_context__.v({
  "className": "ibm_plex_mono_4416716-module__k2KyLG__className",
});
